import React from 'react'
import PropTypes from 'prop-types'

export const Button = props => {
  const {
    text,
    disabled,
    classes,
    type,
    ...rest
  } = props
  return (
    <button className={classes} disabled={disabled} type={type} {...rest}>
      {text}
      {props.children}
    </button>
  )
}

Button.propTypes = {
  text: PropTypes.any,
  disabled: PropTypes.bool,
  classes: PropTypes.string,
  type: PropTypes.string,
  children: PropTypes.any,
}
export default Button



// WEBPACK FOOTER //
// ./src/components/button.js